<template>
	<div class='msgBackground'>
		<div class="messageBox">
			<div class="messageHeader" v-if='(!blocked || !sms.inbound)'>
				<div class="messageLabel">
					<i class="zmdi zmdi-dot-circle-alt unaddressedIcon" v-if='checkDate(sms.datetime)' :class="{inactive: !unaddressed, outbound: !sms.inbound }" @click="unaddressedPop = true"></i>
					<i class="zmdi zmdi-comment-text"></i>
					<label class='sub' v-if='!msgMobile'>Text Message</label>
				</div>
				<div class="agentContainerText">
					<div class="imgWrap" v-if='sms.agent && sms.agent.Phonecode && !sms.inbound'>
						<img class='headerImage' v-if='sms.agent.Phonecode.pc_avatar' v-bind:src="sms.agent.Phonecode.pc_avatar">
						<label v-else class="sidebarImageReplacement">{{ getInitials(sms.agent.Phonecode.lename) }}</label>
					</div>
					<label class='sub' v-show='!msgMobile'>
						<div v-if='sms.agent && sms.agent.Phonecode'>{{ sms.agent.Phonecode.lename }}</div>
						<div v-else-if='!sms.agent && !sms.inbound'>Unknown</div>
					</label>
				</div>
				<a class='openIn' v-if='sms.inbound' :href="link+'&textingPod='+sms.SmsThreadId" target="_blank">
					<i class="zmdi zmdi-open-in-new"></i>
				</a>
			</div>

			<div class="inboundLineInfo" v-if="(!blocked && sms.inbound)" v-show='!msgMobile'>
				<i class="zmdi zmdi-account-box-phone"></i>
				<div class='lineLabel'>
					<div class='disclaimer'>{{ sms.label1 }}</div>
					<label class='small'>{{ sms.displaynum }}</label>
				</div>
			</div>

			<div class="messageContent">
				<div class='messageBody' v-if="sms.body && sms.body.trim() != ''">
					<div v-if="!blocked || !sms.inbound">
						{{sms.body}}
					</div>
					<div v-if="blocked && sms.inbound">
						Message removed - customer's texts were blocked by your store.
					</div>
				</div>
				<div class='MMSBody' v-if="!blocked" v-for="attachment in sms.attachment">
					<MultimediaSent :file="attachment.file" :type="attachment.type" :width="attachment.width" :height="attachment.height" @video-player="videoPlayer"></MultimediaSent>
				</div>
			</div>
		</div>

		<div class="triangleContainer">
			<div v-if='sms.inbound' class="leftTriangle"></div>
			<div v-else class="rightTriangle"></div>
		</div>

		<div class="messageWarning" v-if="sms.sendStatus === 0 && !sms.inbound">
			<i class="zmdi zmdi-alert-circle-o"></i>
			<label class='sub'>Not Delivered</label>
		</div>

		<UnaddressedPopup :unaddressedPop="unaddressedPop" :unaddressedNotes="unaddressedNotes" :unaddressed="unaddressed" :accountRefname="account.refname" :loadingUnaddressedChange="loadingUnaddressedChange" 
			@submit-unaddressed-change="submitUnadressedChange()" @close-unaddressed-pop="unaddressedPop = false"></UnaddressedPopup>

		<VideoPopup :currentlyPlaying="currentlyPlaying" :playingFileOfType="playingFileOfType" @close-video-pop="closeVideoPlayer()"></VideoPopup>
	</div>	
</template>

<script>
import $ from 'jquery'
import axios from 'axios'
import moment from 'moment-timezone'
import { mapState } from 'vuex'
import MultimediaSent from '@/components/MultimediaSent'
import UnaddressedPopup from '@/components/UnaddressedPopup'
import VideoPopup from '@/components/VideoPopup'
require('../assets/css/msgDetails.css')

export default {
	name: 'msgDetails',
	props: ["messageindex", "options", "msgMobile", "link", "unaddressed", "displayNum", "trackinglinename", "blocked"],
	components: { MultimediaSent, UnaddressedPopup, VideoPopup },
	computed: {
		...mapState({
			account: state => state.account,
			sms (state) {
				return state.currentMessages[this.messageindex]
			},
			user: state => state.user,
			callmeasurementAPIToken: state => state.callmeasurementAPIToken,
			unaddressedNotes (state) {
				return state.unaddressedLogMap[this.sms.id];
			}
		})
	},
	data: function(){
		return {
			currentlyPlaying: false,
			playingFileOfType: false,
			unaddressedPop:false,
			loadingUnaddressedChange:false
		}
	},
	methods: {
  		getInitials: function(name){
			let nameArray = name.trim().split(' ');
			let initials = '';
			
			if (nameArray.length === 2) {
				initials += nameArray[0][0];
				initials += nameArray[1][0];
			} else if (nameArray.length > 2) {
				initials += nameArray[0][0];
				initials += nameArray[nameArray.length-1][0];
			} else if (nameArray.length === 1) {
				initials += nameArray[0][0];
			}

			return initials;
	    },
		checkDate: function(timestamp){
			return moment(timestamp).isAfter(moment().subtract(45, 'days'));
		},
		submitUnadressedChange: async function(){
			this.loadingUnaddressedChange = true;
			this.unaddressedPop = false;
			const markedAs = !this.unaddressed;
			const today = moment().format('MMMM DD, YYYY hh:mm A');
			const endpoint = `https://callmeasurement-api.callbox.com/unaddressed/text/${this.sms.id}/${this.sms.inbound ? 'in' : 'out'}`;

			if (!this.callmeasurementAPIToken) {
				await this.$store.dispatch('getCallmeasurementAPIToken');
			}

			if (this.unaddressed) {
				let res = await axios.put(endpoint, {
					unaddressed: false,
					userid: this.user.leuserid
				}, {
					headers: {
						Authorization: `Bearer ${this.callmeasurementAPIToken}`
					}
				});

				this.$emit('toggleUnaddressed', {
					unaddressed: false,
					index: this.messageindex,
					datetime: this.sms.tz_datetime
				});
			} else {
				let res = await axios.put(endpoint, {
					unaddressed: true,
					userid: this.user.leuserid
				}, {
					headers: {
						Authorization: `Bearer ${this.callmeasurementAPIToken}`
					}
				});

				this.$emit('toggleUnaddressed', {
					unaddressed: true,
					index: this.messageindex,
					datetime: this.sms.tz_datetime
				});
			}

			this.$store.commit('addUnaddressedLog', { ActionDatetime: today, descrip1: this.user.descrip1, FlaggedAs: markedAs, CommunicationId: this.sms.id, preserve: true });
			this.loadingUnaddressedChange = false;
		},
		videoPlayer: function(file, type){
			this.currentlyPlaying = file;
			this.playingFileOfType = type;
		},
		closeVideoPlayer: function(){
			this.currentlyPlaying = false;
			this.playingFileOfType = false;
		}
	}
}
</script>